import { useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import SearchPopularArtists from "../components/SearchPopularArtists";
import MediaGridView from "../components/MediaGridView";
import { searchArtistsByValue } from '../data/artists';
import { searchAlbumsByValue } from '../data/albums';
import { searchSinglesByValue } from '../data/singles';
import SectionHeader from '../components/SectionHeader';
import Footer from '../components/Footer';
import NotFountParagraph from '../components/NotFountParagraph';

const SearchResults = () => {

  document.title = "Search Results";

  const { value } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [popularArtists, setPopularArtists] = useState([]);
  const [popularAlbums, setPopularAlbums] = useState([]);
  const [popularSingles, setPopularSingles] = useState([]);
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get('type') || '';

  useEffect(() => {
    if (!value) {
      navigate('/search');
      return;
    }
    if (value && !type) {
      setPopularArtists(searchArtistsByValue(value, 4));
      setPopularAlbums(searchAlbumsByValue(value, 4));
      setPopularSingles(searchSinglesByValue(value, 4));
    } else if (value && type) {
      switch (type.toLowerCase()) {
        case 'artists':
          setPopularArtists(searchArtistsByValue(value));
          break;
        case 'albums':
          setPopularAlbums(searchAlbumsByValue(value));
          break;
        case 'singles':
          setPopularSingles(searchSinglesByValue(value));
          break;
        default:
          break;
      }
    }
  }, [value, type, navigate]);

  return (
    <div className="pt-[4rem] mx-2 sm:mx-4 md:mx-8 lg:mx-12 xl:mx-16 2xl:mx-20 min-h-screen">
      {type ? (
        <>
          {type === "artists" ? (
            <>
              <SectionHeader title={`Top Artists for "${value}"`} />
              <SearchPopularArtists artists={popularArtists} />
            </>
          ) : type === "albums" ? (
            <>
              <SectionHeader title={`Top Albums for "${value}"`} />
              <MediaGridView collection={popularAlbums} />
            </>
          ) : type === "singles" ? (
            <>
              <SectionHeader title={`Top Singles for "${value}"`} />
              <MediaGridView collection={popularSingles} />
            </>
          ) : ""}
        </>
      ) : (
        <>
          {popularArtists.length > 0 && (
            <>
              <SectionHeader title={`Top Artists for "${value}"`} />
              <SearchPopularArtists artists={popularArtists} />
            </>
          )}

          {popularAlbums.length > 0 && (
            <>
              <SectionHeader title={`Top Albums for "${value}"`} />
              <MediaGridView collection={popularAlbums} />
            </>
          )}

          {popularSingles.length > 0 && (
            <>
              <SectionHeader title={`Top Singles for "${value}"`} />
              <MediaGridView collection={popularSingles} />
            </>
          )}
        </>
      )}
      {popularArtists.length === 0 &&
        popularAlbums.length === 0 &&
        popularSingles.length === 0 && (
          <NotFountParagraph />
        )}
      <Footer />
    </div>
  );
};

export default SearchResults;